import { createSelector } from 'reselect';
import PredesComplianceMessageMappingErrorsSummaryColumns
  from '../../containers/PredesComplianceMessageMappingErrorsSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMessageMappingErrorsSummaryColumns);
